import React from "react";
import TablaModeracion from "js/pages/Admin/Programa/Moderacion/Tabla";

function Moderacion(props) {
  return <TablaModeracion {...props} />;
}

export default Moderacion;
